<template>
  <q-footer elevated>
    <q-toolbar elevated>
      <div class="flex col-12 row items-center justify-between">
        <div
          class="col-8 div-progress q-pa-sm justify-center flex items-center"
        >
          <q-linear-progress
            size="md"
            :value="progressBarValue"
            color="red-9"
            rounded
          />
        </div>
        <div
          class="col-4 justify-center flex items-center"
          v-if="progressBarValue == maxValue && isShowSubmitButton"
        >
          <q-btn
            unelevated
            rounded
            color="red-9"
            @click="isLoading ? '' : finishFn()"
            label="Concluir"
            :disable="isLoading"
            :loading="isLoading"
          />
        </div>
        <div
          class="col-2 div-btn-next justify-center flex items-center"
          v-else
        >
          <q-btn
            round
            color="red-9"
            @click="nextTabFn()"
            icon="arrow_forward"
          />
        </div>
      </div>
    </q-toolbar>
  </q-footer>
</template>
<script>
  export default {
    name: "FooterToolbar",
    props: {
      progressBarValue: Number,
      maxValue: Number,
      finishFn:{
        type: Function,
        required: false,
      },
      nextTabFn: Function,
      isLoading: Boolean,
      isShowSubmitButton: {
        type: Boolean,
        default: true,
      },
    },

    setup(props, { emit }) {
      return {};
    },
  };
</script>

<style scoped>

footer {
    background: #ffffff;
    height: 12vh;

    .q-toolbar {
      height: 12vh;
    }

    .div-progress {
      height: 8vh;
    }

    .div-btn-next {
      height: 8vh;
    }
  }
</style>